import { useTranslation } from 'react-i18next'
import { SpecialRequestFormField } from '../../../types/enums'
import { IElementProps } from '../../../types/interfaces'

const CustomersSelect = (props: IElementProps) => {
  const { t } = useTranslation('common')

  const optionsToRender = Object.entries(props.externalData?.data ?? {}).map(([key, value]) => ({
    name: value,
    value: key,
    enabledWhen: true,
  }))

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="selectArea selectfuelCard required-highlight">
            <select
              onChange={(e) => props.handleChange(props.name, e, false, SpecialRequestFormField.CustomersSelect)}
              value={props.selectedCompnyId || ''}
              disabled={props.formReadOnly || props.disabledInput}
            >
              <option disabled={true} value="">
                {optionsToRender.length > 0 ? t('PLEASE_SELECT_A_VALUE') : t('NO_VALUE_TO_SHOW')}
              </option>
              {optionsToRender.length > 0 &&
                optionsToRender.map((option, i) => (
                  <option value={option.value} key={i} disabled={!option.enabledWhen}>
                    {option.name}
                  </option>
                ))}
            </select>
            <i className="icon-bottom" />
          </div>
        </div>
      )}
    </>
  )
}
export default CustomersSelect
